import { dramaMeta, keywordLinks, navItems } from "@/mocks/drama";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-primary-900 text-primary-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-quill-pen-line" />
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                {dramaMeta.title}
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-200">
              {dramaMeta.intro}
            </p>
            <p className="mt-4 flex items-start gap-2 text-xs leading-relaxed text-primary-300">
              <i className="ri-information-line mt-0.5" />
              <span>{dramaMeta.note}</span>
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">
              页面导航
            </h4>
            <ul className="mt-4 grid grid-cols-2 gap-2 md:grid-cols-1 md:gap-2.5">
              {navItems.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    className="text-sm text-primary-200 transition hover:text-accent-400"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">
              相关查询
            </h4>
            <ul className="mt-4 flex flex-wrap gap-2">
              {keywordLinks.map((kw) => (
                <li key={kw}>
                  <a
                    href="#ending"
                    className="inline-block rounded-full border border-primary-700 px-3 py-1 text-xs text-primary-100 transition hover:border-accent-500 hover:text-accent-400"
                  >
                    {kw}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-primary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {dramaMeta.title} · 剧情解析站</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-star-smile-line text-accent-400" />
            内容仅用于剧情理解与观看辅助
          </p>
        </div>
      </div>
    </footer>
  );
}